import { useState, useEffect } from "react";

import PropTypes from "prop-types";

import ThreeLevelMessage from "../../utils/ThreeLevelMessage";

import { useTranslation } from "react-i18next";

import {
  // CURRENT_COVERAGE_URL,
  LEARN_MORE_URL,
  REG_HUB_ADD_TOPIC,
} from "../../constants/urls";

import CardsDeckCustom from "../../utils/CardsDeckCustom";

import { connect } from "react-redux";
import { isIPad13 } from "react-device-detect";
import {
  WORKSPACE_TYPE_PRIVATE,
  PARTNER,
} from "../../constants/stringConstants";

import CustomModal from "../../utils/CustomModal";

import FieldsInForm from "../../utils/FieldsInForm";

import {
  createNewTopic,
  topicErrorMessageRaised,
  topicSuccessMessageRaised,
} from "../../actions/topicActions";

import { bindActionCreators } from "redux";

import { Row, Col } from "react-bootstrap";
import AlertMessage from "../../utils/AlertMessage";

const CuratedByRegHubContainer = ({
  curatedRegHubTopics,
  loggedIn,
  userRights,
  currentWorkspace,
  createNewTopic,
  userToken,
  user,
  topicErrorMessage,
  topicSuccessMessage,
  topicErrorMessageRaised,
  topicSuccessMessageRaised,
}) => {
  const { t } = useTranslation(),
    [isAddEditDialogShown, setIsAddEditDialogShown] = useState(false),
    [addNewTopicOccurred, setAddNewTopicOccurred] = useState(false),
    argsForAddTopicDialog = {
      findFormErrors: (form) => {
        const { TOPIC_NAME, SEARCH_CRITERIA } = form;
        const newErrors = {};

        if (!TOPIC_NAME) newErrors.TOPIC_NAME = t("topicNameIsMandatoryField");

        if (
          SEARCH_CRITERIA === undefined ||
          SEARCH_CRITERIA?.split(";").length < 2
        )
          newErrors.SEARCH_CRITERIA = t("youMustDefineAtLeast2SearchCriteria");
        return newErrors;
      },
      fields: [
        {
          name: "TOPIC_NAME",
          type: "text-field",
          required: true,
          label: t("nameOfTopic"),
          placeholder: t("egRiskManagement"),
        },
        {
          name: "SEARCH_CRITERIA",
          type: "textarea",
          required: false,
          label: t("searchCriteria"),
          placeholder: t("pleaseAddSearchCriteria"),
        },
      ],
      onSubmit: (values) => {
        createNewTopic(
          userToken,
          values.TOPIC_NAME,
          // "name_of_selected_topic1;name_of_selected_topic2",
          values.SEARCH_CRITERIA,
          true,
          user.USER_EMAIL,
          currentWorkspace.WORKSPACE_TYPE === WORKSPACE_TYPE_PRIVATE
            ? "private"
            : "public"
        );
        setIsAddEditDialogShown(false);
        setAddNewTopicOccurred(false);
      },
    },
    [failureMessage, setFailureMessage] = useState(""),
    [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    if (topicErrorMessage) {
      setFailureMessage(topicErrorMessage);
    }

    if (topicSuccessMessage) {
      setSuccessMessage(topicSuccessMessage);
    }
  }, [
    topicErrorMessage,
    setFailureMessage,
    topicSuccessMessage,
    setSuccessMessage,
  ]);

  return (
    <>
      <ThreeLevelMessage
        classNameOfContainer="three-level-message-container"
        classNameOfLevel1="three-level-message-container1 fs-21"
        classNameOfLevel2="three-level-message-container2 fs-12"
        classNameOfLevel3="three-level-message-container3 fs-12 cursor-pointer"
        textOfLevel1={t("curatedByRegHubHeadline")}
        textOfLevel2={t("curatedByRegHubSubHeadline")}
        textOfLevel3={t("learnMore")}
        // textOfLevel4={t("currentCoverage")}
        level3URL={LEARN_MORE_URL}
        // level4URL={CURRENT_COVERAGE_URL}
      />
      <CardsDeckCustom
        classNameOfCard="homepage-card apply-border-white-color"
        classNameOfCardsColumns={
          isIPad13
            ? "homepage-cards-for-iPad homepage-cards-columns"
            : "homepage-cards-columns"
        }
        classNameOfOverlay="homepage-card-overlay"
        cards={curatedRegHubTopics}
        loggedIn={loggedIn}
        fromMySelection={false}
        fromCuratedByRegHub={true}
        addTopicFunctionality={() => {
          if (
            (currentWorkspace.WORKSPACE_TYPE === WORKSPACE_TYPE_PRIVATE &&
              userRights.USER_RIGHT.toLowerCase().includes(PARTNER)) ||
            userRights.USER_RIGHT.toLowerCase().includes(PARTNER) ||
            (userRights.USER_RIGHT.toLowerCase().includes(
              "read_write_delete_new"
            ) &&
              currentWorkspace.WORKSPACE_TYPE !== WORKSPACE_TYPE_PRIVATE)
          )
            setIsAddEditDialogShown(true);
        }}
        canAddTopic={
          currentWorkspace.WORKSPACE_TYPE != undefined &&
          userRights != undefined &&
          userRights.USER_RIGHT != undefined
            ? (currentWorkspace.WORKSPACE_TYPE === WORKSPACE_TYPE_PRIVATE &&
                userRights.USER_RIGHT.toLowerCase().includes(PARTNER)) ||
              userRights.USER_RIGHT.toLowerCase().includes(PARTNER) ||
              (userRights.USER_RIGHT.toLowerCase().includes(
                "read_write_delete_new"
              ) &&
                currentWorkspace.WORKSPACE_TYPE !== WORKSPACE_TYPE_PRIVATE)
            : false
        }
      />
      <CustomModal
        titleOfModal={t("addTopic")}
        positiveButton={t("save")}
        negativeButton={t("cancel")}
        negativeAction={() => setIsAddEditDialogShown(false)}
        setIsShown={setIsAddEditDialogShown}
        isShown={isAddEditDialogShown}
        positiveAction={() => setAddNewTopicOccurred(true)}
        classNameOfModal="add-topic-modal"
        formId="add-topic-modal-form"
        isBackdrop="static"
        content={
          <Row className="add-topic-row">
            <Col className="add-topic-first-col">
              <span className="add-topic-first-col-label">
                {t("newTopicFirstLabel")}
              </span>
              <FieldsInForm
                idOfForm="add-topic-modal-form"
                fields={argsForAddTopicDialog.fields}
                onSubmit={argsForAddTopicDialog.onSubmit}
                findFormErrors={argsForAddTopicDialog.findFormErrors}
                setSubmitOccurred={setAddNewTopicOccurred}
                submitOccurred={addNewTopicOccurred}
              />
            </Col>
            <Col className="add-topic-second-row">
              <span className="add-topic-second-col-label">
                {t("withSearchCriteriaYouCanSpecify")}
                <a
                  rel="noreferrer"
                  href={REG_HUB_ADD_TOPIC}
                  className="add-topic-link"
                  target="_blank"
                >
                  {t("thisLink")}
                </a>
              </span>
            </Col>
          </Row>
        }
        isCentered={true}
      />
      {failureMessage ? (
        <AlertMessage
          variant="danger"
          onClose={() => {
            setFailureMessage("");
            topicErrorMessageRaised("");
          }}
          successHeading={t("failure")}
          mainMessage={failureMessage}
        />
      ) : (
        <div className="display-none" />
      )}
      {successMessage ? (
        <AlertMessage
          variant="success"
          onClose={() => {
            setSuccessMessage("");
            topicSuccessMessageRaised("");
          }}
          successHeading={t("success")}
          mainMessage={successMessage}
        />
      ) : (
        <div className="display-none" />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    curatedRegHubTopics: state.topicReducer.curatedRegHubTopics,
    userRights: state.userReducer.userRights,
    currentWorkspace: state.configReducer.currentWorkspace,
    user: state.userReducer.user,
    userToken: state.configReducer.userToken,
    topicErrorMessage: state.topicReducer.topicErrorMessage,
    topicSuccessMessage: state.topicReducer.topicSuccessMessage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    createNewTopic: bindActionCreators(createNewTopic, dispatch),
    topicErrorMessageRaised: bindActionCreators(
      topicErrorMessageRaised,
      dispatch
    ),
    topicSuccessMessageRaised: bindActionCreators(
      topicSuccessMessageRaised,
      dispatch
    ),
  };
};

CuratedByRegHubContainer.propTypes = {
  curatedRegHubTopics: PropTypes.arrayOf(
    PropTypes.shape({
      CREATED_BY: PropTypes.string,
      SUBSCRIPTION: PropTypes.string,
      TOPIC_AUDIENCE: PropTypes.string,
      TOPIC_ICON_PATH: PropTypes.string,
      TOPIC_ID: PropTypes.number,
      TOPIC_NAME: PropTypes.string,
      TOPIC_SEARCHTAGS: PropTypes.string,
      TOPIC_STATUS: PropTypes.string,
    })
  ),
  loggedIn: PropTypes.bool.isRequired,
  userRights: PropTypes.shape({
    USER_NAME: PropTypes.string,
    USER_RIGHT: PropTypes.string,
    USER_TOKEN: PropTypes.string,
    WORKSPACE_TYPE: PropTypes.string,
  }),
  currentWorkspace: PropTypes.shape({
    WORKSPACE_TYPE: PropTypes.string,
  }).isRequired,
  user: PropTypes.shape({
    USER_EMAIL: PropTypes.string,
  }).isRequired,
  userToken: PropTypes.string.isRequired,
  createNewTopic: PropTypes.func.isRequired,
  topicErrorMessage: PropTypes.string.isRequired,
  topicSuccessMessage: PropTypes.string.isRequired,
  topicErrorMessageRaised: PropTypes.func.isRequired,
  topicSuccessMessageRaised: PropTypes.func.isRequired,
};

CuratedByRegHubContainer.defaultProps = {
  curatedRegHubTopics: PropTypes.arrayOf(
    PropTypes.shape({
      CREATED_BY: "",
      SUBSCRIPTION: "FALSE",
      TOPIC_AUDIENCE: "",
      TOPIC_ICON_PATH: "",
      TOPIC_ID: 0,
      TOPIC_NAME: "",
      TOPIC_SEARCHTAGS: "",
      TOPIC_STATUS: "",
    })
  ),
  loggedIn: false,
  userRights: PropTypes.shape({
    USER_NAME: "",
    USER_RIGHT: "",
    USER_TOKEN: "",
    WORKSPACE_TYPE: "",
  }),
  currentWorkspace: PropTypes.shape({
    WORKSPACE_TYPE: "",
  }).isRequired,
  user: {
    USER_EMAIL: "",
  },
  topicErrorMessage: "",
  topicSuccessMessage: "",
  topicErrorMessageRaised: () => {},
  topicSuccessMessageRaised: () => {},
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CuratedByRegHubContainer);
